import React, { useContext, useEffect } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Controller, useFormContext } from 'react-hook-form';
import { useEditInputStyles } from './styles';
import { emailRegex } from '@utils/regex';
import useClient from '@hooks/useClient';
import { MyAccountContext } from '@routes/MyAccount/MyAccountContainer';

interface Props {
  onEmailVerficationClick: (value: string) => void;
  isSendVerficationCode: boolean;
  onSubmit: (_: any) => void;
  onCancel: () => void;
  isAuth: boolean;
}

const EmailEditPresenter: React.FC<Props> = ({
  onEmailVerficationClick,
  isSendVerficationCode,
  onSubmit,
  onCancel,
  isAuth
}) => {
  const classes = useEditInputStyles();
  const { clientState } = useClient();
  const originEmail = clientState.email;
  const { control, watch, setValue } = useFormContext();
  const context = useContext(MyAccountContext);
  const editEmail = watch().email;
  const authNum = watch().authCode;

  useEffect(() => {
    setValue('email', context.DecodedaccessTokenEmail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CustomizedTypography
        color="textSecondary"
        variant="body1"
        gutterBottoms={12}
      >
        이메일
      </CustomizedTypography>
      <Grid container wrap="nowrap" justifyContent="space-between">
        <Controller
          control={control}
          name="email"
          defaultValue={context.DecodedaccessTokenEmail ?? ''}
          rules={{
            pattern: {
              value: emailRegex,
              message: '유효하지 않은 이메일입니다.'
            }
          }}
          render={(renderProps) => {
            return (
              <TextField
                {...renderProps}
                classes={{ root: classes.email }}
                placeholder={'이메일을 입력하세요.'}
                InputProps={{
                  classes: {
                    root: classes.InputRoot,
                    input: classes.input
                  }
                }}
                variant="outlined"
                fullWidth
              />
            );
          }}
        />
        <CustomizedButton
          fullWidth
          variant="outlined"
          color="primary"
          disabled={originEmail === editEmail}
          onClick={() => onEmailVerficationClick(editEmail ?? '')}
          classes={{
            root: classes.certificationBtn,
            outlinedSecondary: classes.outlinedSecondary
          }}
        >
          {isSendVerficationCode ? '재전송' : '인증하기'}
        </CustomizedButton>
      </Grid>
      <Controller
        control={control}
        name="authCode"
        defaultValue=""
        render={(renderProps) => {
          return (
            <TextField
              {...renderProps}
              InputProps={{
                classes: {
                  root: classes.InputRoot,
                  input: classes.input
                }
              }}
              placeholder="인증번호를 입력해주세요."
              variant="outlined"
              fullWidth
              disabled={isSendVerficationCode ? false : true}
            />
          );
        }}
      />
      <Grid container className={classes.buttonContainer}>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="outlined"
          color="primary"
          size="medium"
          onClick={onCancel}
        >
          취소하기
        </CustomizedButton>
        <CustomizedButton
          fullWidth
          className={classes.button}
          variant="contained"
          color="primary"
          size="medium"
          onClick={onSubmit}
          disabled={!isAuth || !authNum}
        >
          수정하기
        </CustomizedButton>
      </Grid>
    </>
  );
};

export default EmailEditPresenter;
